import GridToolbarProps from './Toolbar'
import Vue from 'vue'

let KendoGridToolbar = {
    name: 'kendo-grid-toolbar-item',
    render () {
        return Vue.prototype._e
    },
    mixins: [GridToolbarProps]
}

export default KendoGridToolbar


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGridToolbar/index.js